export default {
  'Watermark': '워터마크',
  'Add Watermark Selection': '워터마크 선택구역을 추가합니다.',
}